import { useState } from 'react';

import { Tooltip } from '../tooltip/tooltip';
import { Widget } from '../widget/widget';
import { Icon } from '../icon/icon';

import './input-box.css';

export function InputBox(props) {
    const [focused, setFocused] = useState(false);

    const keyPressed = key => {
        if (key !== "Enter") {
            return;
        }

        if (props.submitted) {
            props.submitted();
        }
    };

    const valueChanged = value => {
        if (props.valueChanged) {
            props.valueChanged(value);
        }
    };

    const showErrorIndicator = (props.mandatory && !props.value) || props.error;
    const hasFocus = focused ? "has-focus" : "";
    const hasError = props.error ? "has-error" : "";
    const isDisabled = props.disabled ? "is-disabled" : "";
    const className = props.class ? props.class : "";

    return (
        <div className={`input-box ${isDisabled} ${hasFocus} ${hasError} ${className}`}>
            {props.label &&
                <div className="input-box-label-container">
                    <label className="input-box-label">
                        { props.label }
                        { showErrorIndicator &&
                            <Icon name="ic_asterisk" class="error-indicator" />
                        }
                    </label>
                    { props.tooltip &&
                        <Tooltip text={props.tooltip} position="left">
                            <Icon name="ic_info-fill" class="input-box-tooltip-icon" />
                        </Tooltip>
                    }
                </div>
            }
            <div className="input-box-container">
                { props.icon &&
                    <Icon name={props.icon} class="input-box-icon" />
                }
                <input
                    type={props.type ? props.type : "text"}
                    placeholder={props.placeholder}
                    value={props.value}
                    readOnly={props.readonly}
                    disabled={props.disabled}
                    onKeyPress={event => keyPressed(event.key)}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onChange={event => valueChanged(event.target.value)}
                    />
                { props.children }
            </div>
            
            { props.error &&
                <Widget variant="alert" class="input-box-error">
                    <Icon name="ic_alert-outline" class="input-box-error-icon" />
                    <span>
                        { props.error }
                    </span>
                </Widget>
            }
        </div>
    );
}